<template>
  <div>
    <ul>
      <li v-for="(item, index) in list" :key="index">
        <div class="d-flex justify-content-between mt-2">
          <p>{{ item.name }}</p>
          <ts-button
            outline
            color="info"
            class="btn-xs"
            v-tooltip="'Add to list'"
            @click.prevent="pickItem(item)"
          >
            <i class="fa fa-plus"></i>
          </ts-button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'componentList',
  props: ['list'],
  methods: {
    pickItem(item) {
      this.$emit('add', item)
    }
  }
}
</script>
